import React from 'react';
import { CardGroup, Paper, ValueCard } from 'library';

import './ValuesBlock.scss';

const ValuesBlock = () => {
  return (
    <div className="ValuesBlock">
      <Paper theme="medium" pad={{ top: 10, bottom: 10 }}>
        <h2 className="ValuesBlockTitle">Our Values</h2>
        <CardGroup cardSize={ValueCard.size} title="We are owners" preventOrphans>
          <ValueCard icon="execute" title="We execute...with intention">
            We value getting things done… and well. We move fast but do so thoughtfully. We see success as finishing
            rather than starting.
          </ValueCard>
          <ValueCard icon="check" title="We roll up our sleeves">
            There's no job too big or too small. If there's something to be done, we step up and make it happen vs.
            waiting for others to volunteer.
          </ValueCard>
          <ValueCard icon="lightbulb" title="We create solutions">
            We’re resourceful. We get creative and ask the right questions to figure out what it would take to solve a
            problem.
          </ValueCard>
        </CardGroup>
        <CardGroup cardSize={ValueCard.size} title="We are good neighbors" preventOrphans>
          <ValueCard icon="team" title="We collaborate with trust">
            We respect each other's authority and expertise. We give each other the benefit of the doubt. We are
            confident in our ideas, but our minds can be changed.
          </ValueCard>
          <ValueCard icon="star" title="We put the team and the homeowner first">
            We are accountable to each other & to homeowners. We put ourselves in each others' shoes. We realize that
            the key to success is making sure we build value for others.
          </ValueCard>
          <ValueCard icon="speech" title="We communicate directly & constructively">
            We speak openly and clearly across teams and levels. We have an obligation to dissent - we see giving and
            receiving feedback as our responsibility.
          </ValueCard>
        </CardGroup>
      </Paper>
    </div>
  );
};

export default ValuesBlock;
